<template>
  <div class="global-search-wrapper" style="width: 600px">
    <a-auto-complete
      class="certain-category-search"
      dropdown-class-name="certain-category-search-dropdown"
      :dropdown-match-select-width="false"
      size="large"
      style="width: 100%;"
      :placeholder="$t('fileManager.searchAnything')"
      option-label-prop="title"
      @select="onSelect"
      @search="handleSearch"
    >
      <template slot="dataSource">
        <a-select-opt-group v-if="folders.length > 0">
          <span slot="label">
            Folders
          </span>
          <a-select-option
            v-for="item in folders"
            :key="item.data.attributes.name + '_' + item.data.id"
            :title="item.data.id"
          >
            <!--Folder Icon-->
            <a>
              <div class="ts-flex">
                <div class="ts-justify-start">
                  <i :class="iconSize" class="fas fa-folder text-primary"></i>
                </div>
                <div>
                  {{ item.data.attributes.name }}
                  <br />
                  <small class="ts-opacity-50"
                    >{{
                      item.data.attributes.items > 0
                        ? item.data.attributes.items + ' itmes'
                        : 'Empty'
                    }}
                    {{ item.data.attributes.updated_at }}</small
                  >
                </div>
              </div>
            </a>
          </a-select-option>
        </a-select-opt-group>

        <a-select-opt-group v-if="files.length > 0">
          <span slot="label">
            Files
          </span>
          <a-select-option
            v-for="item in files"
            :key="item.data.attributes.name + '_' + item.data.id"
            :title="item.data.id"
          >
            <!--File Icon-->
            <a @click="onOpen(item.data)">
              <div class="ts-flex">
                <file-icon-thumbnail
                  :entry="item"
                  :icon-size="iconSize"
                  :is-icon="true"
                  class="pr-2"
                />
                <div>
                  {{ item.data.attributes.name }}
                  <br />
                  <small class="ts-opacity-50"
                    >{{ item.data.attributes.filesize }}
                    {{ item.data.attributes.updated_at }}</small
                  >
                </div>
              </div>
            </a>
          </a-select-option>
        </a-select-opt-group>
      </template>
      <a-input>
        <a-icon
          slot="suffix"
          :type="loading ? 'loading' : 'search'"
          class="certain-category-icon"
        />
      </a-input>
    </a-auto-complete>
  </div>
</template>
<script>
import FileIconThumbnail from './FileIconThumbnail'
import * as FileDownload from 'downloadjs'
import { debounce } from 'lodash'
export default {
  name: 'search',
  components: {
    FileIconThumbnail
  },
  data () {
    return {
      loading: false,
      iconSize: 'fa-2x',
      search: ''
    }
  },
  computed: {
    folders () {
      return this.$store.state.fileManager.fileBrowser.folders
    },
    files () {
      return this.$store.state.fileManager.fileBrowser.files
    }
  },
  methods: {
    onSelect (value) {
      console.log('onSelect', value)
    },
    handleSearch: debounce(function (query) {
      this.loading = true
      this.search = query
      this.$store
        .dispatch('fileManager/fileBrowser/getBrowseSearch', {
          query: query
        })
        .finally(() => {
          this.loading = false
        })
    }, 1000),

    async onOpen (data) {
      if (data.type === 'folder') {
        this.$store.commit(
          'fileManager/fileBrowser/SET_CURRENT_FOLDER_ID',
          data.id
        )
        this.$router.push({
          name: 'file-manager-folder',
          params: { id: data.id }
        })
        this.$emit('fetchCurrentFolder')
      }
      if (data.type === 'video') {
        this.showVideoForm(data.attributes)
      }
      if (data.attributes.mimetype === 'pdf') {
        this.showPdfForm(data.attributes)
      }
      if (data.type === 'image') {
        this.$viewerApi({
          images: [data.attributes.file_url]
        })
      }
      if (
        data.attributes.mimetype ===
        'vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        if (
          await this.$confirmModal.danger(
            'Are you sure to download ' + data.attributes.name + '?'
          )
        ) {
          FileDownload(data.attributes.file_url)
        }
      }
      if (
        data.attributes.mimetype ===
        'vnd.openxmlformats-officedocument.wordprocessingml.document'
      ) {
        if (
          await this.$confirmModal.danger(
            'Are you sure to download ' + data.attributes.name + '?'
          )
        ) {
          FileDownload(data.attributes.file_url)
        }
      }
      if (
        ['mpeg', 'mp3', 'mp4', 'wan', 'flac', 'ogg'].includes(
          data.attributes.mimetype
        ) &&
        data.type === 'audio'
      ) {
        this.showAudioForm(data.attributes)
      }
      if (data.attributes.mimetype === 'zip') {
        if (
          await this.$confirmModal.danger(
            'Are you sure to download ' + data.attributes.name + '?'
          )
        ) {
          FileDownload(data.attributes.file_url)
        }
      }
      if (data.attributes.mimetype === 'plain') {
        if (
          await this.$confirmModal.danger(
            'Are you sure to download ' + data.attributes.name + '?'
          )
        ) {
          FileDownload(data.attributes.file_url)
        }
      }
    }
  }
}
</script>

<style scoped>
.global-search-wrapper {
  padding-right: 50px;
}

.global-search {
  width: 100%;
}

.global-search.ant-select-auto-complete .ant-select-selection--single {
  margin-right: -46px;
}

.global-search.ant-select-auto-complete
  .ant-input-affix-wrapper
  .ant-input:not(:last-child) {
  padding-right: 62px;
}

.global-search.ant-select-auto-complete
  .ant-input-affix-wrapper
  .ant-input-suffix
  button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.global-search-item {
  display: flex;
}

.global-search-item-desc {
  flex: auto;
  text-overflow: ellipsis;
  overflow: hidden;
}

.global-search-item-count {
  flex: none;
}
.certain-category-search-dropdown .ant-select-dropdown-menu-item-group-title {
  color: #666;
  font-weight: bold;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item-group {
  border-bottom: 1px solid #f6f6f6;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item {
  padding-left: 16px;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item.show-all {
  text-align: center;
  cursor: default;
}

.certain-category-search-dropdown .ant-select-dropdown-menu {
  max-height: 300px;
}
.certain-category-search-wrapper
  >>> .certain-category-search.ant-select-auto-complete
  .ant-input-affix-wrapper
  .ant-input-suffix {
  right: 12px;
}
.certain-category-search-wrapper >>> .certain-search-item-count {
  position: absolute;
  color: #999;
  right: 16px;
}
.certain-category-search-wrapper
  >>> .certain-category-search.ant-select-focused
  .certain-category-icon {
  color: #108ee9;
}
.certain-category-search-wrapper >>> .certain-category-icon {
  color: #6e6e6e;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 16px;
}
</style>
